import styled from 'styled-components';

export const Top = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	min-width: 0; /* Ensures children can shrink below their content size */
	padding-right: 14px;
`;

export const Spacer = styled.div`
	flex: 0 1 auto;
	min-width: 4px; /* Ensures the spacer can shrink. also nice to have a bit of a space here */
`;

export const ButtonWrapper = styled.div`
	margin-right: 8px;
`;

export const ProfileIconWrapper = styled.div`
	display: flex;
	align-items: center;
	margin-left: 8px;
`;

export const FooterButton = styled.div`
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 16px;
	margin-top: 16px;
	padding-left: 16px;
	padding-right: 16px;
	min-width: 180px;
	max-width: 100%;
`;

export const Spacer2 = styled.div`
	flex: 1;
`;
